import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const client = axios.create({ baseURL: API });

export async function fetchBenchmarks() {
  const { data } = await client.get("/benchmarks");
  return data;
}

export async function resolveBenchmarks(payload) {
  const { data } = await client.post("/benchmarks/resolve", payload);
  return data;
}

export async function calculate(payload) {
  const { data } = await client.post("/calculate", payload);
  return data;
}

export async function createReport(payload) {
  const { data } = await client.post("/reports", payload);
  return data;
}

export async function getReport(slug) {
  const { data } = await client.get(`/reports/${slug}`);
  return data;
}

export async function createCheckoutSession(payload) {
  const { data } = await client.post("/payments/checkout", payload);
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await client.get(`/payments/status/${sessionId}`);
  return data;
}